"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M39.4793 4.16666H9.47928C8.07032 4.16666 6.71907 4.72636 5.72278 5.72265C4.72649 6.71894 4.16678 8.07019 4.16678 9.47916V43.2292C4.1647 43.5371 4.25487 43.8386 4.42567 44.0948C4.59647 44.351 4.84009 44.5502 5.12512 44.6667C5.41031 44.7896 5.72599 44.8236 6.03082 44.7641C6.33565 44.7047 6.61541 44.5545 6.83345 44.3333L13.8751 37.2917H40.2293C41.5102 37.1227 42.6839 36.4874 43.5257 35.5072C44.3675 34.5271 44.8183 33.2709 44.7918 31.9792V9.47916C44.7918 8.78151 44.6544 8.09069 44.3874 7.44615C44.1204 6.80161 43.7291 6.21596 43.2358 5.72265C42.7425 5.22934 42.1568 4.83802 41.5123 4.57105C40.8677 4.30407 40.1769 4.16666 39.4793 4.16666ZM41.6668 31.9792C41.6556 32.4286 41.5137 32.8649 41.2584 33.235C41.0031 33.605 40.6455 33.8925 40.2293 34.0625H13.4585C13.2191 34.0253 12.9745 34.0436 12.7433 34.1158C12.5122 34.1881 12.3007 34.3124 12.1251 34.4792L7.29178 39.4583V9.47916C7.29178 8.92662 7.51128 8.39672 7.90198 8.00602C8.29268 7.61532 8.82258 7.39582 9.37512 7.39582H39.4793C39.7615 7.38169 40.0437 7.42513 40.3086 7.52348C40.5735 7.62183 40.8156 7.77305 41.0202 7.96793C41.2249 8.16281 41.3877 8.39728 41.4988 8.65708C41.61 8.91688 41.6671 9.19658 41.6668 9.47916V31.9792Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M24.4793 10.8542C24.0649 10.8542 23.6675 11.0188 23.3744 11.3118C23.0814 11.6048 22.9168 12.0023 22.9168 12.4167V22.6458C22.9168 23.0602 23.0814 23.4577 23.3744 23.7507C23.6675 24.0437 24.0649 24.2083 24.4793 24.2083C24.8937 24.2083 25.2911 24.0437 25.5841 23.7507C25.8772 23.4577 26.0418 23.0602 26.0418 22.6458V12.4167C26.0418 12.0023 25.8772 11.6048 25.5841 11.3118C25.2911 11.0188 24.8937 10.8542 24.4793 10.8542Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M24.4793 26.4167C24.1702 26.4167 23.8682 26.5083 23.6112 26.68C23.3543 26.8517 23.154 27.0957 23.0357 27.3812C22.9175 27.6667 22.8865 27.9809 22.9468 28.284C23.0071 28.5871 23.1559 28.8655 23.3744 29.084C23.5929 29.3025 23.8714 29.4513 24.1745 29.5116C24.4776 29.5719 24.7917 29.541 25.0772 29.4227C25.3627 29.3045 25.6068 29.1042 25.7785 28.8472C25.9501 28.5903 26.0418 28.2882 26.0418 27.9792C26.0418 27.5648 25.8772 27.1673 25.5841 26.8743C25.2911 26.5813 24.8937 26.4167 24.4793 26.4167Z",
    fill: fill
  }));
};

exports["default"] = _default;